var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4451 20.9607L16.9674 16.4751M19.4488 10.4803C19.4488 12.7304 18.5549 14.8884 16.9639 16.4795C15.3728 18.0706 13.2148 18.9644 10.9646 18.9644C8.7145 18.9644 6.55652 18.0706 4.96543 16.4795C3.37433 14.8884 2.48047 12.7304 2.48047 10.4803C2.48047 8.23012 3.37433 6.07214 4.96543 4.48105C6.55652 2.88996 8.7145 1.99609 10.9646 1.99609C13.2148 1.99609 15.3728 2.88996 16.9639 4.48105C18.5549 6.07214 19.4488 8.23012 19.4488 10.4803V10.4803Z",
    stroke: "#2C2C2C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.237e2ced298b1863889769635f44c71a.svg";
export { ForwardRef as ReactComponent };